import AuthController from '@/controllers/AuthController';
import apiClient from '../apiClient';
import axios from 'axios';
/**
 * Login request
 * @param {string} identityNumber - User's identity number
 * @param {string} password - User's password
 * @returns {Promise<Object>} - The response data from the server
 * @throws {Error} - Throws an error with a descriptive message if the request fails
 */
export const login = async (identityNumber, password) => {
  try {
    // Perform the login API call
    const response = await apiClient.post(`Auth/login`, {
      identityNumber,
      password,
    });
    return response.data;
  } catch (error) {
    // Handle errors
    if (error.response && error.response.data && error.response.data.isError) {
      throw new Error(error.response.data.error?.description || 'An error occurred');
    } else {
      throw new Error('An unexpected error occurred. Please try again later.');
    }
  }
};

/**
 * Send OTP for 2FA verification
 * @param {string} sessionId - Session ID from login response
 * @param {number} method - MFA method (0=SMS, 1=Email, 2=Authenticator, 3=Backup)
 * @returns {Promise<Object>} - The response data from the server
 * @throws {Error} - Throws an error with a descriptive message if the request fails
 */
export const sendOtp2FA = async (sessionId, method) => {
  try {
    const response = await apiClient.post('Auth/send-otp-2fa', {
      sessionId,
      method
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.isError) {
      throw new Error(error.response.data.error?.description || 'Failed to send OTP');
    } else {
      throw new Error('Failed to send OTP. Please try again later.');
    }
  }
};

/**
 * Verify OTP for 2FA authentication
 * @param {Object} verificationData - Contains sessionId, otp, and method
 * @returns {Promise<Object>} - The authentication response with tokens and user data
 * @throws {Error} - Throws an error with a descriptive message if the request fails
 */
export const verifyOtp2FA = async (verificationData) => {
  try {
    const response = await apiClient.post('Auth/verify-otp-2fa', verificationData);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.isError) {
      throw new Error(error.response.data.error?.description || 'Invalid verification code');
    } else {
      throw new Error('Invalid verification code. Please try again.');
    }
  }
};

/**
 * Get user information
 * @returns {Promise<Object>} - The user data from the server
 * @throws {Error} - Throws an error with a descriptive message if the request fails
 */
export const getUserInfo = async () => {
  try {
    const response = await apiClient.get('Auth/user-info');
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.isError) {
      throw new Error(error.response.data.error?.description || 'Failed to get user info');
    } else {
      throw new Error('Failed to get user information. Please try again later.');
    }
  }
};

/***
* Refresh token request
*/
export const newRefreshToken = async (tokenData) =>{
  try{
    const response = await axios.post(`${ process.env.VUE_APP_API_BASE_URL }${AuthController.refreshToken}`,tokenData);
    return response.data;
  }catch(error){
    //throw new Error('An unexpected error occurred. Please try again later.');
    // alert('An unexpected error occurred. Please try again later.')
  }
}


/*******
 * externalRegister
 * Function to handle external user registration by sending a POST request
 * to the API's external sign-up endpoint with the provided user data.
 *
 * @param {Object} userData - Data containing user registration details.
 * @returns {Object} - Response data from the API if the request is successful.
 * @throws {Error} - Custom error message if the API returns an error or if an unexpected error occurs.
 ******/
export const externalRegister = async (userData) => {
  try{
    let response = await axios.post(`${ process.env.VUE_APP_API_BASE_URL }${AuthController.externalSignUp}`,userData);
    return response.data
  }catch(error){
    if (error.response && error.response.data && error.response.data.isError) {
      throw new Error(error.response.data.error.description);
  } else {
      //console.error("Unexpected error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
  }
  }
}


/*******
 * externalLogin
 * Function to handle external user login by sending a POST request
 * to the API's external sign-in endpoint with the provided user data.
 *
 * @param {Object} userData - Data containing user login details.
 * @returns {Object} - Response data from the API if the request is successful.
 * @throws {Error} - Custom error message if the API returns an error or if an unexpected error occurs.
 ******/
export const externalLogin = async (userData) => {
  try{
    return apiClient.post(`${AuthController.externalSignIn}`,userData);
   // return response.data
  }catch(error){
    if (error.response && error.response.data && error.response.data.isError) {
      throw new Error(error.response.data.error.description);
  } else {
      //console.error("Unexpected error:", error);
      throw new Error("An unexpected error occurred. Please try again.");
  }
  }
}
